"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HttpClient = void 0;
/**
 * Abstract HTTP client for making requests against HTTP endpoints of the service under test.
 *
 * Note that concrete implementations of this class are provided in framework specific packages,
 * e.g. for NestJS and ExpressJS.
 */
class HttpClient {
    /**
     * Makes an HTTP GET request.
     */
    async get(path, headers = {}, body) {
        return await this.request("GET", path, headers, body);
    }
    /**
     * Makes an HTTP POST request.
     */
    async post(path, headers = {}, body) {
        return await this.request("POST", path, headers, body);
    }
    /**
     * Makes an HTTP PUT request.
     */
    async put(path, headers = {}, body) {
        return await this.request("PUT", path, headers, body);
    }
    /**
     * Makes an HTTP PATCH request.
     */
    async patch(path, headers = {}, body) {
        return await this.request("PATCH", path, headers, body);
    }
    /**
     * Makes an HTTP DELETE request.
     */
    async delete(path, headers = {}, body) {
        return await this.request("DELETE", path, headers, body);
    }
}
exports.HttpClient = HttpClient;
//# sourceMappingURL=http-client.js.map